/**
 * Does this account still owe the three answers sign-up stopped asking for?
 *
 * Sign-up is an email and a password. The company name, first name and surname are asked
 * on /welcome, which cannot be skipped — so until they are answered the app must send
 * everybody back there, or they wander it as a nameless person on the wallchart, the org
 * chart and every approval email.
 *
 * ⚠️ THIS LIVES IN lib/ RATHER THAN INSIDE App.js SO IT CAN BE TESTED FOR REAL. It was
 * originally a helper in App.js, which cannot be imported by a plain node check because it
 * pulls in React and every page in the product — so the first version of its test
 * exercised a hand-copied duplicate of the rule instead. A test of a copy proves the copy
 * works. See essentialsGate.checks.mjs.
 *
 * ⚠️ "NOT LOADED" IS NOT "EMPTY", AND CONFUSING THE TWO COST A BLANK SCREEN ON STAGING
 * (Rob, 15/08/2026). `/auth/me` returned the user but no tenant, so after any page reload
 * the client had a name and no company name. Treating that absence as "unanswered" sent
 * them to /welcome; /welcome asked the server, which correctly said nothing was owed and
 * forwarded them to /onboarding; and this rule sent them straight back. An infinite
 * redirect, rendering as a blank page.
 *
 * So: `undefined` means nobody has told us yet — **do not redirect**. `null` or `''` or
 * whitespace means the server has told us, and the answer is that it is empty. Failing
 * open here is safe because /welcome checks with the server itself, so anyone who really
 * does owe it is still caught; failing closed is what spins.
 */

const known = (value) => value !== undefined;
const empty = (value) => !String(value ?? '').trim();

export function owesEssentials(user, tenant) {
  if (!user) return false;

  if (known(user.first_name) && empty(user.first_name)) return true;
  if (known(user.last_name) && empty(user.last_name)) return true;

  // The tenant object is only populated by login(); on a reload the company name arrives
  // on the user payload instead. Prefer the tenant when it's there, fall back to the user.
  // ⚠️ `??` not `||` — an empty-string company name on the tenant is a real answer
  // ("unanswered"), and must not fall through to the user's copy.
  const company = tenant?.company_name ?? user.company_name;
  if (known(company) && empty(company)) return true;

  return false;
}

export default owesEssentials;
